import React from 'react';

const Button = ({
  type = 'button',
  disabled,
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`bg-primary hover:bg-primary/85 disabled:bg-primary/60 flex cursor-pointer items-center justify-center gap-2 rounded-lg px-4 py-2 text-white transition-all disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
